import React, { useContext } from "react";
import DrawNewStudent from "./DrawNewStudent";
import VND from "../../components/VND";
import Lang from "../../components/Lang";
import Loading from "../../Loading";
import StudentsAtLocation from "./StudentsAtLocation";
import Error from "../../components/Error";
import useDB from "../../hooks/useDB";
import Month from "../../components/Month";
import { CenterContext } from "../../../../Context";


export default function NewStudents({ year, month }) {
  const {locations} = useContext(CenterContext)
  const [newStudents, setNewStudents, error, loading] = useDB(
    `/new-students/${year}/${month}`
  );

  if (loading) return <Loading />
  if (error) return <Error />

  console.log(newStudents)

     let revenue = 0;
  let payments = 0;
  let noAttendance = 0
  let noBills = 0
     for (let student of newStudents) {
       revenue += student.bills.reduce((a, b) => a + b.amount, 0);
       payments += student.bills
         .filter((b) => b.paymentId)
         .reduce((a, b) => a + b.amount, 0);
       if(!student.firstAttendance) noAttendance++
        if ((!student.bills || student.bills.length === 0) && student.firstAttendance) noBills++
     }


   return (
     <div>
       <h3 className="dflex-sb">
         <div>
           New students in <Month value={month + 1} /> ({newStudents.length}){" "}
         </div>
         <StudentsAtLocation students={newStudents} />
         <div
           style={{ fontSize: 14, fontWeight: "normal", textAlign: "right" }}
         >
           <div>
             Revenue: <VND value={revenue} />, Payments:{" "}
             <VND value={payments} />
           </div>
           <div>
             No attendance: {noAttendance}, No bills {noBills}
           </div>
         </div>
       </h3>
       {locations.map((l) => (
         <div>
           <h3>
             {l.name} ({newStudents.filter((s) => checkLocation(s, l)).length}),
             Revenue:{" "}
             {getRevenue(newStudents.filter((s) => checkLocation(s, l)))},
             Average:{" "}
             {getAverage(newStudents.filter((s) => checkLocation(s, l)))}
           </h3>
           <div className="new-lost-students-table-title">
             <div style={{ width: 320 }}>
               <Lang w="name" />
             </div>
             <div style={{ width: 150 }}>
               <Lang w="customer" />
             </div>
             <div style={{ width: 120 }}>
               <Lang w="dateEnrolled" />
             </div>
             <div style={{ width: 150 }}>
               <Lang w="dateOfFirstClass" />
             </div>
             <div style={{ width: 220 }}>
               <Lang w="consultantsNotes" />
             </div>
             <div style={{ width: 300 }}>
               <Lang w="attendance" />
             </div>
             <div style={{ width: 150 }}>
               <Lang w="bills" />
             </div>
             <div style={{ width: 150 }}>
               <Lang w="consultant" />
             </div>
           </div>
           {newStudents
             .filter((s) => checkLocation(s, l))
             .map((student) => (
               <DrawNewStudent
                 student={student}
                 key={student._id}
               />
             ))}
         </div>
       ))}{" "}
       <h3 style={{ color: "red" }}>
         No location or class (
         {newStudents.filter((s) => s.classes.length === 0).length})
       </h3>
       {newStudents
         .filter((s) => s.classes.length === 0)
         .map((student) => (
           <DrawNewStudent
             student={student}
             key={student._id}
           />
         ))}
     </div>
   );
}

function checkLocation(student, location) {

  if (!student.classes || student.classes.length === 0) return false;
  return student.classes.some((c) => c.location === location._id);
}

function getRevenue(students) { 
  let revenue = 0;
  for (let student of students) {
    revenue += student.bills.filter(b=>b.paymentId).reduce((a, b) => a + b.amount, 0);
  }
  return <VND value={revenue} />;
}

function getAverage(students) {
  let revenue = 0;
  let count = 0
  for (let student of students) {
    let bills = student.bills
    .filter((b) => b.paymentId)
    .reduce((a, b) => a + b.amount, 0);
    revenue += bills
    if(bills > 0) count++;
  }
  return <VND value={count > 0 ? revenue / count : 0} />;
}